export function halt (event) {
  event.preventDefault()
  event.stopPropagation()
}
